'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var Data = require("../data");
var Generators = require("./MineGenerators");
var SeedRandom = require("seedrandom");
/**
 * Generates a new minefield. Returns the minefield and the number of tiles
 * already revealed.
 */
function generateMinefield(gameSeed, dimensions, numMines) {
    var prng = SeedRandom(gameSeed);
    var minefield;
    var revealTiles;
    var _loop_1 = function () {
        minefield = [];
        for (var i = 0; i < dimensions.rows * dimensions.cols; i++) {
            minefield.push({
                revealed: false,
                hasMine: false,
                hasFlag: false,
                numAdjacentMines: 0,
            });
        }
        var offsets = [
            [-1, -1], [-1, 0], [-1, 1], [0, -1], [0, 1], [1, -1], [1, 0], [1, 1]
        ];
        var mines = Generators.pureRNG(dimensions, numMines, prng);
        mines.forEach(function (mineTileIndex) {
            minefield[mineTileIndex].hasMine = true;
            var adjacentTiles = findTileIndexes(dimensions, mineTileIndex, offsets);
            adjacentTiles.forEach(function (tileIndex) {
                minefield[tileIndex].numAdjacentMines++;
            });
        });
        revealTiles = chooseInitialPatch(dimensions, minefield, prng);
    };
    do {
        _loop_1();
    } while (revealTiles === null);
    revealTiles.forEach(function (index) {
        minefield[index].revealed = true;
    });
    return ({ minefield: minefield, numRevealed: revealTiles.length });
}
exports.generateMinefield = generateMinefield;
/**
 * Finds all the relevant tile indexes, by applying the offsets to the index
 * of focus. Will only return valid tile indexes.
 */
function findTileIndexes(dimensions, focusIndex, offsets) {
    var indexes = [];
    var rowIndex = Math.floor(focusIndex / dimensions.cols);
    var colIndex = focusIndex - rowIndex * dimensions.cols;
    offsets.forEach(function (offset) {
        var rowOffset = offset[0], colOffset = offset[1];
        if (rowIndex + rowOffset < 0 || colIndex + colOffset < 0 ||
            rowIndex + rowOffset >= dimensions.rows ||
            colIndex + colOffset >= dimensions.cols) {
            return;
        }
        indexes.push(colIndex + colOffset + (rowIndex + rowOffset) * dimensions.cols);
    });
    return (indexes);
}
exports.findTileIndexes = findTileIndexes;
/**
 * Determines the tiles that should be revealed based on 1 tile becoming
 * revealed. Only returns valid and not revealed tile indexes.
 */
function calcTilesToReveal(minefield, tileIndex, dimensions) {
    if (!isTileEmpty(minefield[tileIndex])) {
        return ([tileIndex]);
    }
    var offsets = [
        [-1, -1], [-1, 0], [-1, 1], [0, -1], [0, 1], [1, -1], [1, 0], [1, 1]
    ];
    var tilesToReveal = [];
    var queue = [tileIndex].concat(findTileIndexes(dimensions, tileIndex, offsets));
    do {
        var index = queue.pop();
        if (index === undefined || tilesToReveal.includes(index)) {
            continue;
        }
        if (!minefield[index].revealed) {
            tilesToReveal.push(index);
        }
        if (isTileEmpty(minefield[index])) {
            queue.push.apply(queue, findTileIndexes(dimensions, index, offsets));
        }
    } while (queue.length > 0);
    return (tilesToReveal);
}
exports.calcTilesToReveal = calcTilesToReveal;
/**
 * Selects one of the empty patches of tiles or returns null if there are no
 * empty patches.
 */
function chooseInitialPatch(dimensions, minefield, prng) {
    var numberTiles = dimensions.rows * dimensions.cols;
    var queue = [];
    minefield.forEach(function (tile, index) {
        if (isTileEmpty(tile)) {
            queue.push(index);
        }
    });
    var emptyPatches = [];
    var checkedTiles = [];
    while (queue.length > 0) {
        var index = queue.pop();
        if (index === undefined || checkedTiles.includes(index)) {
            continue;
        }
        var patch = calcTilesToReveal(minefield, index, dimensions);
        checkedTiles.push.apply(checkedTiles, patch);
        if (patch.length >= Math.round(Data.initialPatchMinSize * numberTiles)) {
            emptyPatches.push(patch);
        }
    }
    if (emptyPatches.length === 0) {
        return (null);
    }
    else {
        return (emptyPatches[Math.floor(prng() * emptyPatches.length)]);
    }
}
function isTileEmpty(tile) {
    return (!tile.hasMine && tile.numAdjacentMines === 0);
}
//# sourceMappingURL=MinefieldUtils.js.map


//////////////////
// WEBPACK FOOTER
// ./src/js/utils/MinefieldUtils.js
// module id = 38
// module chunks = 0